import React from 'react';
import { FaPhoneAlt } from "react-icons/fa";

const HeroImage = () => {
    return (
        <div className="hero bg-white pt-20">
            <div className="hero-content p-0 bg-white flex-col-reverse lg:flex-row">
                <img alt='HeroImage' src='/asset/heroimg.jpg' className=" sm:w-full lg:max-w-lg" />
                <div className='p-5'>
                    <h1 className="text-6xl font-bold"><span className='text-4xl px-3 py-1 bg-amber-400'>I Deliver</span><br/>Healthy Homemade Food</h1>
                    <p className="py-6">I take order for meals, lunch, breakfast, snacks, dinner, Birthday Cake, Ice Cream and so on. Customer Satisfaction is my goal. Are you hungry? Call now!</p>
                    <button className="btn btn-warning mb-5"> <FaPhoneAlt/> <span className='pl-2'>+8801707403698</span></button>
                </div>
            </div>
        </div>
    );
};

export default HeroImage;